import React from 'react';
import PropTypes from 'prop-types';
import "../project-form.scss";
import ProjectNameField from './project-name-field';
import ProjectPriorityField from './project-priority-field';
import ProjectTemplateField from './project-template-field';
import ProjectStartDate from './project-start-date';
import ProjectEndDate from './project-end-date';
import SelectMemberProject from '../../../../../components/select-member/select-member-project';
import MultipleOwnerSelectMemberProject from '../../../../../components/select-member/multiple-owner-select-member-project';

const ProjectPageLeftPanel = (
    {
        data,
        selectedOwner,
        selectedOwners,
        isMultiOwner,
        canTransferOwner,
        priorities, 
        projectTemplates,
        setFormState,
        errors,
        user,
        isEdit,
        labels
    }) => {

  return (
    <div className="project-create-left-panel">
        <div className="row align-items-baseline">
            <ProjectNameField
                value={data.Name}
                handleChange={(field, value) => setFormState(field, value)}
                errors={errors.Name}
                labels={labels}
            />
            <ProjectPriorityField 
               handleChange={(field, value) => setFormState(field, value)}
               priorityValue={data.Priority}
               priorities={priorities}
            />
        </div>
        <div className="row">
           <ProjectTemplateField
                value={data.ParentTemplateName}
                handleChange={(field, value) => setFormState(field, value)}
                projectTemplates={projectTemplates}
                isEdit={isEdit}
                labels={labels}
           />
        </div>
        <div className="row">
            <ProjectStartDate 
                handleChange={(field, value) => setFormState(field, value)}
                startDate={data.Start}
                maxDate={data.End}
                errors={errors.Start}
            />
            <ProjectEndDate 
                handleChange={(field, value) => setFormState(field, value)}
                endDate={data.End}
                minDate={data.Start}
                errors={errors.End}
            />
        </div>
        <div className="row">
            {
                isMultiOwner ?
                <MultipleOwnerSelectMemberProject
                data={data}
                saveMembers={(newMembers) => setFormState("Members", newMembers)}
                saveOwners={(newOwners) => setFormState("Owner", newOwners)}
                selectedOwners={selectedOwners}
                user={user}
                isEdit={isEdit}
                isMultiOwner={isMultiOwner}
                labels={labels}
                disabled={!canTransferOwner && !isEdit}
                canTransferOwner={canTransferOwner}
                /> :
                <SelectMemberProject
                data={data}
                saveMembers={(newMembers) => setFormState("Members", newMembers)}
                saveOwner={(newOwner) => setFormState("Owner", newOwner)}
                selectedOwner={selectedOwner}
                user={user}
                isEdit={isEdit}
                labels={labels}
                disabled={!canTransferOwner && !isEdit}
                />
            }
        </div>
    </div>
  )
}

ProjectPageLeftPanel.propTypes = {
    priorities: PropTypes.array.isRequired,
    projectTemplates: PropTypes.array.isRequired,
    setFormState: PropTypes.func.isRequired,
    errors: PropTypes.object,
    data: PropTypes.object.isRequired,
    selectedOwner: PropTypes.object,
    isEdit: PropTypes.bool,
    user: PropTypes.object.isRequired,
    selectedOwners: PropTypes.array,
    isMultiOwner: PropTypes.bool,
    canTransferOwner: PropTypes.bool,
    labels: PropTypes.shape({
        ProjectSingular: PropTypes.string,
        ProjectPlural: PropTypes.string,
        ProjectSingularPossessive: PropTypes.string,
        ProjectPluralPossessive: PropTypes.string,
    }),
};

export default ProjectPageLeftPanel;